// extracted by mini-css-extract-plugin
export default {"cell":"AssignmentsMatrixView_cell__tcxgP","clickable":"AssignmentsMatrixView_clickable__saP3r"};